import {
  Dmenu
} from './dmenu.js'; //ドロワーメニュー
import {
  Env
} from './env.js'; //ブラウザなど環境チェック
//import { youtubeLazy } from './youtube-lazyload.js';//Youtube遅延(スクロール到達時)読み込み
import {
  ScrChecker
} from './scroll-checker-simple.js';
import {
  Opening
} from './opening.js'; //オープニング関連
import {
  LogoutRedirect
} from './logout-redirect.js'; //サイズを整数に
import {
  PageAncher
} from './pageancher.js'; //ページ内アンカーリンク（スムーズスクロール）

//リサイズ
import {
  ResizeElem
} from './resize.js';

import smoothscroll from 'smoothscroll-polyfill';
// window.scroll smooth not working on Safari
// https://stackoverflow.com/questions/51731754/window-scroll-smooth-not-working-on-safari
// Window.scroll() https://developer.mozilla.org/en-US/docs/Web/API/Window/scroll

export class Main {
  constructor() {
    this.timerResized = false; //resize時
    this.timerScrolled = false; //scroll時
    this._click = '';
    this.env = {};
    //this.youtubeLazy = {};
    this.loadedFlg = false;
    this.scrChecker = {};
    //this.pageAncher = {};
    //this.accordions = {};
    this.sliders = {};
    this.openingManager = {};
    this.tabs = {};
    //this.sizeint= {};
    this.resize = {};
    this.logoutRedirect = {};
  }

  init() {
    //console.log('init');
    //this.scrCheck = new ScrPos();
    this.body = document.getElementsByTagName('body')[0];
    this.html = document.getElementsByTagName('html')[0];

    // DOMContentLoaded時
    // ------------------------------
    window.addEventListener('DOMContentLoaded', () => {

      // ブラウザOS環境
      this.env = new Env();
      this.env.detectEnv();

      // スクロールチェッカー
      this.scrChecker = new ScrChecker();
      this.scrChecker.init();


      //page ancher
      smoothscroll.polyfill();
      this.pageAncher = new PageAncher();
      this.pageAncher.init();

      // Resize
      this.resize = new ResizeElem();


      // スクロール時
      window.addEventListener('scroll', () => {
        //console.log(this.env.browser.ie11);

        // ie11もヘッダー関係で
        //if (this.env.browser.ie11 !== true) {
        this.scrChecker.onUpdate();
        //}

      });

      // ウインドウリサイズ時
      window.addEventListener('resize', () => {
        // ie11もヘッダー関係で
        //if (this.env.browser.ie11 !== true) {
        this.scrChecker.onUpdate();
        //this.sizeint.sizeInt();
        //}
        var _this = this;
        if (this.timerResized !== false) {
          clearTimeout(this.timerResized);
        }
        this.timerResized = setTimeout(() => {
          //this.accordions.accResize();
          this.resize.resizing();
        }, 700);
      });

      // dmenu
      let dmenu = new Dmenu();
      dmenu.init();

      // アコーディオン
      //this.accordions = new Acc();
      //this.accordions.init();


      // Openingチェッカー
      this.openingManager = new Opening(this.env);
      this.openingManager.init();

      // Opening開始 load時でなくてOK?
      // if (this.openingManager.flg) {
      //     this.openingManager.startOpening();
      // } else {
      //     this.openingManager.skipOpening();
      // }

      //resize
      this.resize.resizing();

    });

    // load時
    // ------------------------------
    window.addEventListener("load", () => {
      this.loadedFlg = true;
      window.setTimeout(() => {
        this.body.classList.add('loaded');
        //this.body.classList.add('opening-skipped'); //OP設置前のみ
      }, 100);

      //youtube lazyload
      // this.youtubeLazy = new youtubeLazy();
      // this.youtubeLazy.init();
      // this.youtubeLazy.onScroll();

      //URLパラメータ
      //this.paramAncher = new Pla();
      //this.paramAncher.getParam('pa', location.href);

      //ログアウトリンク クリック時リダイレクト
      //this.logoutRedirect = new LogoutRedirect();
      //this.logoutRedirect.init();

      // ie11もヘッダー関係で
      //if(this.env.browser.ie11 !== true){
      var _this = this;
      window.setTimeout(function () {
        _this.scrChecker.onUpdate();
        //console.log('loaded, scrChecker.onUpdate');
      }, 500);
      //}

      // announcement barなど
      this.resize.resizing();

      // Opening開始
      if (this.openingManager.flg) {
        this.openingManager.startOpening();
      } else {
        this.openingManager.skipOpening();
        //this.resize.resizing();
        //this.openingManager.initYoutube();
        //this.body.classList.add('opening-skipped');
        //this.indexSlider.play();
      }


      // Swiper
      // this.sliders = new Swp();
      // this.sliders.init();

      // Tab
      // this.tabs = new Tab();
      // this.tabs.init();

      //整数サイズへ
      //this.sizeint.sizeInt();

    });
  }
}